import Link from 'next/link'
import QRCode from 'qrcode.react'
import cn from 'classnames'

import Android from '../../assets/android.png'
import Apple from '../../assets/apple.png'
import IconCopy from 'images/account/copy.svg'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'
import { useEffect, useState } from 'react'
import { CopyButtonWithSuccess } from 'components/ui/copy-button-with-success'

export function QrCodeMobile({ className }: { className?: string }) {
  const { t } = useTranslation()
  const [platform, setPlatform] = useState<'ios' | 'android' | 'unknown'>('unknown')

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase()

    if (ua.includes('android')) {
      setPlatform('android')
    } else if (/iphone|ipad|ipod/.test(ua)) {
      setPlatform('ios')
    } else {
      setPlatform('unknown')
    }
  }, [])

  return (
    <div className={cn(styles.qr, className)}>
      <h3 className={styles.qr__title} dangerouslySetInnerHTML={{
        __html: t('scan_to_download')
      }}></h3>

      <div className={styles.qr__content}>
        <QRCode value="http://onelink.to/d3w5vg" size={144} />

        <div className={styles.mobiles}>
          {
            platform !== 'android' && <Link
              href="https://apps.apple.com/de/app/google-authenticator/id388497605"
              prefetch={false}>
              <button className={styles.storeBtn}>
                <img src={Apple} alt="Apple logo" width={90} height={24} className={styles.mobiles__image} />
              </button>
            </Link>
          }
          {
            platform !== 'ios' && <Link
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=ru&gl=US"
              prefetch={false}
            >
              <button className={styles.storeBtn}>
                <img src={Android} alt="Android logo" width={104} height={24} className={styles.mobiles__image} />
              </button>
            </Link>
          }
        </div>
      </div>
    </div>
  )
}

export function QrCodeText(props) {
  const { t } = useTranslation()

  return (
    <div className={styles.qr}>
      <div className={styles.qr__content}>
        <QRCode
          value={`otpauth://totp/CoinRabbit:${props.credentials}?secret=${props.value}&issuer=CoinRabbit`}
          size={144} />
        <div className={cn(styles.qr__text, styles.qr__text_content_code)}>
          <div className={cn(styles.qr__title, styles.qr__title_code)}>
            <p>{props.value}</p>
            <CopyButtonWithSuccess
              value={props.value}
              className={styles.iconBtn}
              successIconClassName={styles.iconSuccess}
              customIcon={IconCopy} />
          </div>
          <p className={styles.qr__subtitle}>
            {t('enter_code_manually')}
          </p>
        </div>
      </div>
    </div>
  )
}
